<template>
	<footer>
		<div class="footer-element">
			<div class="row">
				<div class="columns column3">
					<p class="footer-nav">
						<span v-for="item in contentblocks" :key="item.ID">
							<nuxt-link :to="'#' + item.header.trim()">
								{{ item.header }}
							</nuxt-link>
							<br />
						</span>

						<a href="https://www.hotelkint.nl/ons-verhaal/vacatures" target="_blank">
							{{ $t('vacancies') }}
						</a>
						<br />

						<a v-if="defaults[locale].cookieConsent.published" href="#" @click.prevent="openConsent">
							{{ $t('consentOpen') }}
						</a>
					</p>
				</div>
				<div class="columns column3 contact-info">
					<p>
						<strong>{{ defaults[locale].website.hotelName }}</strong>
						<br />
						<span>{{ defaults[locale].website.street }} {{ defaults[locale].website.number }}</span>
						<br />
						<span>{{ defaults[locale].website.postalCode }} {{ defaults[locale].website.city }}</span>
						<br />
						<span>{{ defaults[locale].website.country }}</span>
						<br />
						<br />
						<a :href="`tel:${$phoneRaw(defaults[locale].website.phone)}`">
							<span>{{ defaults[locale].website.phone }}</span>
						</a>
						<br />
						<a :href="`mailto:${defaults[locale].website.email}`">
							<span>{{ defaults[locale].website.email }}</span>
						</a>
						<br />
						<br />
						<social-media :socials="socials" />
					</p>
				</div>
				<div class="columns column3">
					<div v-parse-links v-html="defaults[locale].website.openingHours" />
				</div>
				<div class="columns column3">
					<newsletter
						:header="defaults[locale].newsletter.title"
						:content="defaults[locale].newsletter.content"
						:button="defaults[locale].newsletter.button"
					/>
					<div class="badges">
						<div class="lekker-logo" />
						<a
							href="https://www.tripadvisor.com/Restaurant_Review-g227912-d26800063-Reviews-Bistro_Francis-Valkenburg_Limburg_Province.html"
							target="_blank"
							class="tripadvisor-badge"
						/>
					</div>
				</div>
			</div>
		</div>
		<div class="footer-element author">
			<div class="row">
				<div class="columns column12 align-center">
					<a href="https://eclect.com/" target="_blank" class="eclect-visual" />
					<p class="align-right">
						<span class="copyright">© All rights reserved / ECLECT</span>
					</p>
				</div>
			</div>
		</div>
	</footer>
</template>

<script setup>
const { locale } = useI18n();
const { defaults, socials, fetchDefaults } = useDefaults();
const { openConsent } = useCookieConsent();

defineProps({
	contentblocks: { type: Array, default: () => [] },
});

await fetchDefaults();
</script>

<style lang="scss" scoped>
.footer-element {
	background: #fff;
	color: var(--body-color);
	padding: 80px 0 10px;
	font-size: 16px;
	line-height: 22px;

	p {
		line-height: 22px;
	}
}

.footer-element hr {
	background: #f4f0e7;
}

.footer-element a {
	color: var(--body-color);
	font-weight: 700;

	&:hover {
		color: var(--cta-color);
	}
}

.contact-info a {
	font-weight: 400;
}

.footer-element.author {
	font-size: 12px;
}

.author {
	padding: 50px 0 20px;

	.column12 {
		display: flex;
		flex-wrap: nowrap;
		justify-content: space-between;
		align-items: flex-end;

		p {
			margin: 0;
		}
	}

	.copyright {
		margin: 0 0 0 25px;
	}
}

.eclect-visual {
	background: url('~/assets/images/footer-eclect-visual.svg') no-repeat center center;
	width: 31px;
	height: 31px;
	background-size: 31px;
	margin: -5px 0 5px;
}

.lekker-logo {
	background: url('~/assets/images/logo-lekker-2026.png') no-repeat center center;
	background-size: 100%;
	width: 150px;
	height: 150px;
	margin: 40px 0 0;
}

.tripadvisor-badge {
	background: url('~/assets/images/tripadivsor-badge-2025.png') no-repeat center center;
	background-size: 100%;
	width: 100px;
	height: 110px;
	margin: 40px 0 0;
	display: block;
}

.badges {
	display: flex;
	flex-flow: row wrap;
	justify-content: center;
	align-items: center;
	gap: 25px;
}

.footer-logo {
	max-width: 180px;
	margin: 0 0 30px;
}

.socials a {
	color: #fff;
	background: var(--cta-color);
	width: 40px;
	height: 40px;
	line-height: 40px;
	text-align: center;
	font-size: 22px;
	margin: 5px 5px 5px 0;
	text-decoration: none;

	&:hover {
		color: #fff;
		background: var(--cta-color-hover);
	}
}

@media (max-width: 920px) {
	.footer-element {
		padding: 60px 0 10px;

		.columns {
			margin: 10px auto;
		}
	}
}

@media (max-width: 680px) {
	.footer-element {
		text-align: left;
	}
}
</style>
